import { initializeApp } from "firebase/app";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

// Your Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyDEBnx0rXUZ6E88t7pQmv04pl8ykmzk1u8",
  // Served from our own domain via the Netlify proxy in public/_redirects so the
  // sign-in handler is same-origin with the app (fixes "missing initial state"
  // on storage-partitioned mobile browsers).
  authDomain: "yourtop8.com",
  projectId: "your-top-8",
  storageBucket: "your-top-8.firebasestorage.app",
  messagingSenderId: "680003462304",
  appId: "1:680003462304:web:f2fba206e3f4159fa155c5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// App Check (reCAPTCHA v3) — anti-abuse. Only turns on once the site key is set
// (REACT_APP_RECAPTCHA_SITE_KEY), so the app keeps working until you register the
// site in the console. For local dev, set REACT_APP_APPCHECK_DEBUG=true and paste
// the printed debug token into Firebase Console > App Check > Debug tokens.
const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
if (recaptchaSiteKey) {
  if (process.env.REACT_APP_APPCHECK_DEBUG === 'true') {
    // eslint-disable-next-line no-restricted-globals
    self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
  }
  try {
    initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider(recaptchaSiteKey),
      isTokenAutoRefreshEnabled: true,
    });
  } catch (e) {
    console.error('App Check init failed:', e);
  }
}

// Export initialized Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);
